/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import ModalConfirmation from '../../../../common/components/ModalConfirmation';

export type ModalActionType = 'GroupsDelete' | 'AnalysesDelete';

export type GroupsModalProps = {
  id?: number;
  show?: boolean;
  onConfirm?: ((id: number) => void) | undefined;
  onCancel?: (() => void) | undefined;
  modalActionType?: ModalActionType;
  additionalClass?: string;
};

type ModalData = {
  title?: string;
  message?: string;
  confirmButtonText?: string;
  /* eslint-disable  @typescript-eslint/no-explicit-any  */
  i18Instance?: any;
};

const getModalData = (modalType: ModalActionType, t: TFunction): ModalData => {
  switch (modalType) {
    case 'AnalysesDelete':
      return {
        title: t('areyouSureDeleteMsg'),
        message: t('selectedAnalysesWillBeDeleted'),
        confirmButtonText: t('yesDelete'),
      };
    case 'GroupsDelete':
      return {
        title: t('areyouSureDeleteMsg'),
        message: t('parmanentlyRemoveMsg'),
        confirmButtonText: t('yesDelete'),
      };
    default:
      throw new Error('Dialog action type not defined');
  }
};
const GroupsModal: FC<GroupsModalProps> = ({
  id,
  show,
  onConfirm,
  onCancel,
  modalActionType,
  additionalClass,
}) => {
  const { t } = useTranslation();
  const { title, message, confirmButtonText } = getModalData(
    modalActionType!,
    t
  );

  const handleCancel = () => {
    onCancel!();
  };

  const handleConfirm = () => {
    onConfirm!(id!);
  };
  const dialogClass = `modal-confirmation ${additionalClass || ''}`;
  return show ? (
    <ModalConfirmation
      show={show}
      cancelButtonText={t('cancel')}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      confirmTitle={title}
      confirmationMessage={message}
      confirmButtonText={confirmButtonText}
      dialogClassName={dialogClass}
      contentClassName="modal-confirmation"
    />
  ) : null;
};

export default GroupsModal;
